angular.module('arounja.filters').filter('spacesAfterCommas', function() {
	return function(input) {
        return input.replace(/,([^ ])/g, ', $1')
	};
})
